<template>
<div>


    <v-btn fab small :color="buttonClass" @click="showDialog" class="mr-1 element-button elevation-0">
        <v-badge v-if="linkedFileCount">
            <span slot="badge">{{linkedFileCount}}</span>
            <v-icon color="blue darken-1">attach_file</v-icon>
        </v-badge>
        <v-icon v-else color="grey">attach_file</v-icon>
    </v-btn>


    <FileDialog :element="element" :files="files" :settings="fileDialog.settings" />

</div>
</template>

<script>

import UploadFirebase from '../ui-elements/UploadFirebase'
import FileDialog from '../ui-elements/FileDialog'
import Utilities from '../helpers/Utilities'
import ElementHelpers from '../helpers/ElementHelpers'
import AlertHelpers from '../helpers/AlertHelpers';



export default {
    data() {
        return {
            linkMode: false,
            fileDialog: {
                settings: {
                    visible: false,
                    closeOnly: true,
                    title: 'Linked Files',
                },
            }
        
        }
    },

    components: {
        UploadFirebase,
        FileDialog,
    },
    
    props: {
        element: Object,
    },

    computed: {
        linkedFileCount() {

            //todo: remove this later...
            //return ElementHelpers.filesForElement(this.element, this.elements).length

            //keep this...
            if(this.element.linkedFileKeys && this.element.linkedFileKeys.length)
                return this.element.linkedFileKeys.length
            else 
                return 0
        },

        buttonClass() {
            if(this.linkedFileCount)
                return 'blue lighten-3'
            else
                return 'grey lighten-3'
        },
        iconClass() {
            if(this.element.complete)
                return 'blue darken-1'
            else
                return 'grey'
        },

        elements() {
            return this.$store.getters.elements
        },

        files() {
            return this.elements.filter(o => o.type=="File").reverse()
        },  

        transaction() {
            return this.$store.getters.transaction
        },

        uploadedFiles() {
            return ElementHelpers.filesForElement(this.element, this.elements)
        },
    },

    methods: {

        showDialog() {
            this.fileDialog.element = this.element
            this.fileDialog.settings.visible = true
        },

        uploadStart(upload, triggerElement) { 
            Utilities.log('uploadStart', upload)
            upload.tabKey = 'settings'
            upload.transactionKey = this.transaction.key
            upload.type = 'File'
            upload.title = upload.name
            this.saveElement(upload)
        },

        uploadFinish(upload, triggerElement) {
            

            if(!upload.url) {
                console.log('failed upload...deleting')
                this.deleteElement(upload)
            }
            console.log('uploadFinish', upload)

            upload.value = upload.url
            upload.triggerElementKey = triggerElement.key
            upload.name = (triggerElement && triggerElement.targetName ? triggerElement.targetName : upload.name)
            this.saveElement(upload)
        },

        uploadStartAll(triggerElement) {
            Utilities.log('uploadStartAll')
            triggerElement.loading = true
            this.saveElement(triggerElement)
        },
        uploadFinishAll(payload) {
            Utilities.log('uploadFinishAll')

            let triggerElement = payload.returnObject
            triggerElement.complete = true
            triggerElement.loading = false
            this.saveElement(triggerElement)
            AlertHelpers.showAlert('Uploaded ' + payload.files)
        },

        saveElement(element) {
            this.$store.dispatch('saveElement', element)
        },
        deleteElement(element) {
            this.$store.dispatch('deleteElement', element)
        },

        showError(error) {
            this.$emit('error', error)
        },

        hideLoader() {
            this.element.loading = false
            this.saveElement(this.element)
        }

    },

    created() {
    
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// UploadElement.vue?7785c159